export default __webpack_public_path__ + "static/media/Map_inactive.29639068.png";